// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__6pTJB","bigColWidth":"Table_bigColWidth__1hYUF","biggerColWidth":"Table_biggerColWidth__2AyIC","row":"Table_row__1y6NI","col":"Table_col__3vpZz"};